import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import React, { useState } from 'react';
import { observer } from 'mobx-react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import { formatMonthAndDay, formatTime } from 'utils/dateUtil';
import styles from './ScopeChangeRequestBanner.m.sass';
export var ScopeChangeRequestBanner = observer(function (_ref) {
  var scopeChangeRequests = _ref.scopeChangeRequests,
    showScopeChangeRequestResponseDialog = _ref.showScopeChangeRequestResponseDialog;
  var currentRequest = scopeChangeRequests[0];
  var currentRequestIsPendingClientApproval = currentRequest ? currentRequest.isPendingClientApproval : false;
  var currentRequestIsRejected = currentRequest ? currentRequest.isRejected : false;
  var displayBanner = currentRequestIsPendingClientApproval || currentRequestIsRejected || false;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isHidden = _useState2[0],
    setIsHidden = _useState2[1];
  return displayBanner ? /*#__PURE__*/React.createElement("div", {
    className: cx(styles.root, currentRequestIsPendingClientApproval && styles.pendingApproval, currentRequestIsRejected && styles.rejected, isHidden && styles.hidden)
  }, /*#__PURE__*/React.createElement("div", {
    className: styles.container
  }, /*#__PURE__*/React.createElement("div", {
    className: styles.description
  }, currentRequestIsPendingClientApproval && /*#__PURE__*/React.createElement("p", null, /*#__PURE__*/React.createElement("span", {
    className: styles.strong
  }, "Additional amount due"), "\xA0since\xA0", /*#__PURE__*/React.createElement("span", {
    className: styles.strong
  }, formatTime(currentRequest.dateCreated)), "\xA0on\xA0", /*#__PURE__*/React.createElement("span", {
    className: styles.strong
  }, formatMonthAndDay(currentRequest.dateCreated))), currentRequestIsRejected && /*#__PURE__*/React.createElement("p", null, /*#__PURE__*/React.createElement("span", {
    className: styles.strong
  }, "A customer service representative has been notified"), "\xA0of the declined job updates and will be in contact shortly")), /*#__PURE__*/React.createElement("div", {
    className: styles.action
  }, currentRequestIsPendingClientApproval && /*#__PURE__*/React.createElement("button", {
    className: styles.button,
    type: "button",
    onClick: function onClick() {
      return showScopeChangeRequestResponseDialog(currentRequest);
    }
  }, "REVIEW"), currentRequestIsRejected && /*#__PURE__*/React.createElement("button", {
    className: styles.button,
    type: "button",
    onClick: function onClick() {
      return setIsHidden(true);
    }
  }, "CLOSE")))) : null;
});
ScopeChangeRequestBanner.propTypes = {
  scopeChangeRequests: PropTypes.array,
  showScopeChangeRequestResponseDialog: PropTypes.func
};
//# sourceMappingURL=index.js.map
